import {
  FETCH_DEVICE_LOGS_LOADING,
  FETCH_DEVICE_LOGS_SUCCESS,
  FETCH_DEVICE_LOGS_FAILED,
  CLEAR_DEVICE_LOGS
} from "../../actionTypeConstants/ml2.0/DeviceLogs";
import get from "lodash/get";

const initialState = {
  data: null,
  loading: true,
  url: "",
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_DEVICE_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        data: null,
        error: null
      };
    }

    case FETCH_DEVICE_LOGS_SUCCESS: {
      const url = get(action, ["result", "config", "url"], "");
      const deviceLogs = get(action, ["result", "data"], "");
      const newUrl = url ? url.replace("/device?", "/devicezip?") : url;
      return {
        ...state,
        url: newUrl,
        loading: false,
        data: deviceLogs,
        error: null
      };
    }

    case FETCH_DEVICE_LOGS_FAILED: {
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error.response
      };
    }

    case CLEAR_DEVICE_LOGS: {
      return {
        ...state,
        loading: false,
        data: null,
        error: null
      };
    }

    default: {
      return state;
    }
  }
}
